
import { mapActions, mapGetters } from 'vuex';
import UITrendingIndexWidget from '@/components/ui/organism/UITrendingIndexWidget.vue';

export default {
  name: 'TrendingIndicesWidgetWrapper',
  components: { UITrendingIndexWidget },
  computed: {
    ...mapGetters('trendingIndicesWidget', [
      'displayedTrendingIndices',
      'trendingIndicesLoading',
      'trendingIndicesPageSize',
      'showViewMore',
    ]),
  },
  created() {
    this.ensureDataLoaded();
  },
  methods: {
    ...mapActions('trendingIndicesWidget', [
      'ensureDataLoaded',
      'showNextPage',
    ]),
    handleLoadMore() {
      this.showNextPage();
    },
  },
};
